module.exports = __webpack_public_path__ + "fonts/SalesforceSans-BoldItalic.dba3843e5b62ac3c2d9637a98f2207f4.woff2";